import "./__styles__/IconText.scss";
import React, { PropsWithChildren } from "react";
import Icon, { Props as IconProps } from "./Icons";

const IconText = (props: PropsWithChildren<IconProps>) => (
  <div styleName="container">
    <div styleName="icon">
      <Icon {...props} />
    </div>
    <div styleName="text">{props.children}</div>
  </div>
);

export default IconText;
